import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pageMinx from "./mixins/pageMinx";
import { tabulation, gmToolNewPage } from "@/mixins/index";
import { rollData, rollData_currency } from "@/api/index/index";
import { mapState } from "vuex";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  mixins: [tabulation, pageMinx, gmToolNewPage],
  data: function data() {
    return {
      name: 'rollSuit',
      // finallyFn: ['getRollData'],
      PointTime: ['00', '23'],
      serverLists: [],
      tableData: [],
      reqFn: 'getRollData',
      searchData: {
        date: ''
      }
    };
  },
  created: function created() {
    this.searchData.date = this.$times.theDay();
    this.getServerLists();
  },
  computed: _objectSpread(_objectSpread({}, mapState('d2admin/serchSelect', ['royalpirates'])), mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    },
    is_show_homes: function is_show_homes(state) {
      return state.user.is_show_home;
    }
  })),
  mounted: function mounted() {},
  methods: {
    resettingData: function resettingData() {
      this.Data = [];
    },
    getServerList: function getServerList() {
      var _this = this;

      var env_id = this.propsData ? this.propsData.env_id : this.searchData.env_id;
      yjServerList({
        server_channel: this.server_channel,
        show_test: this.show_test,
        env_id: env_id
      }).then(function (res) {
        if (res.code == 200) {
          _this.serverListYJ = res.data;
        }
      });
    },
    //请求服务器列表  用于指定海盗和御剑请求
    getServerLists: function getServerLists() {
      if (this.is_show_homes == 1 || !this.rawData) {
        return;
      }

      this.RollSuit = false;
      this.serverLists = [];
      this.searchData.server_id = '';
      this.searchData.is_prod = '';
      var game = this.rawData.game_mark;

      if (game.indexOf(this.royalpirates) > -1) {
        this.RollSuit = this.severlist.length ? true : false;
      } else if (game.indexOf('yjfm') > -1) {
        this.RollSuit = true;
      }
    },
    severlistChange: function severlistChange(e) {
      var _this2 = this;

      this.serverLists = [];
      this.searchData.server_id = '';

      if (e) {
        hdServerList({
          is_prod: this.searchData.is_prod
        }).then(function (res) {
          if (res.status == 200) {
            _this2.serverLists = res.data;
          }
        });
      }
    },
    getRollData: function getRollData() {
      var _this3 = this;

      var isverification = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.rawData.game_mark) {
        return;
      }

      if (!this.searchData.server_id) {
        this.$message.error('请选择服务器');
        return;
      } // if (this.currencyClose && !this.searchData.currency_info) {
      //   if (isverification) {
      //     this.$message.error('请选择货币类型')
      //   }
      //   return
      // }


      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(replace) {
          var res, dbres, today, todayHoure, date, searchHoour, reqFn, handleQueryData, cacheHourData, cacheHourObj, i, arr, mathNum, querylist, dataList, searchHours, _loop, k, _ret, queryData, _querylist, _dataList, _i, Hds, qd, ii, _arr2, _queryData, _queryData2, _querylist2, _dataList2, _loop2, _i2, _ret2;

          return regeneratorRuntime.wrap(function _callee$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this3.reqLoading = true; // 初始化响应对象

                  res = {
                    data: {}
                  }; // 从数据库获取数据

                  _this3.searchData.hour_start = parseInt(_this3.PointTime[0]);
                  _this3.searchData.hour_end = parseInt(_this3.PointTime[1]);
                  _context3.next = 6;
                  return _this3.$DBControls.get(_this3.name + _this3.dataConvert());

                case 6:
                  dbres = _context3.sent;

                  if (!(dbres && dbres.code == 500)) {
                    _context3.next = 10;
                    break;
                  }

                  _this3.getRollData(true);

                  return _context3.abrupt("return");

                case 10:
                  // const today = '2024-03-07';
                  today = _this3.$times.theDay();
                  todayHoure = _this3.$times.theDay('HH');
                  date = _this3.searchData.date || today;
                  searchHoour = [];

                  _this3.hourList.forEach(function (i) {
                    var h = i < 10 ? "0".concat(i) : i;
                    searchHoour.push(h);
                  }); // 定义请求函数


                  reqFn = _this3.currencyClose ? rollData_currency : rollData;
                  _context3.next = 18;
                  return _this3.getexchangeRate();

                case 18:
                  // 数据处理函数
                  handleQueryData = function handleQueryData(queryData) {
                    if (queryData.code === 200) {
                      var dataToUpdate = JSON.stringify(queryData.data) == '[]' ? {} : queryData.data;
                      var currentHourList = {};

                      if (today == date) {
                        for (var i in dataToUpdate) {
                          var arr = i.split(":");

                          if (parseInt(arr[2]) < todayHoure) {
                            currentHourList[i] = dataToUpdate[i];
                          }
                        }
                      }

                      var storeData = {
                        dataNew: today == date ? {} : dataToUpdate,
                        todayHoure: currentHourList,
                        houreDate: date
                      };

                      _this3.$DBControls.update(_this3.name + _this3.dataConvert(), storeData);

                      res.data = dataToUpdate;

                      _this3.dataHandle(dataToUpdate);
                    }
                  };

                  if (!dbres) {
                    _context3.next = 72;
                    break;
                  }

                  cacheHourData = dbres.content.houreDate == today ? dbres.content.todayHoure : {};
                  cacheHourObj = [];

                  for (i in cacheHourData) {
                    arr = i.split(":");
                    cacheHourObj.push(arr[2]);
                  }

                  cacheHourObj = _toConsumableArray(new Set(cacheHourObj));
                  mathNum = Math.max.apply(null, cacheHourObj) + 1;
                  querylist = [];
                  dataList = [];

                  if (!(today == date)) {
                    _context3.next = 44;
                    break;
                  }

                  searchHours = [];
                  _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(k) {
                    var i, h, Hds, qd, ii, _arr, defaultData;

                    return regeneratorRuntime.wrap(function _loop$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            i = _this3.hourList[k];

                            if (!(i >= mathNum && i < parseInt(_this3.PointTime[1]) && i <= todayHoure)) {
                              _context.next = 16;
                              break;
                            }

                            h = i < 10 ? "0".concat(i) : i;
                            Hds = {
                              hour_start: h,
                              hour_end: h
                            };
                            _context.next = 6;
                            return reqFn(_objectSpread(_objectSpread(_objectSpread({}, _this3.searchData), _this3.defaultData()), {}, {
                              date: date
                            }, Hds));

                          case 6:
                            qd = _context.sent;

                            if (!(qd.status == 200 || qd.code == 200)) {
                              _context.next = 12;
                              break;
                            }

                            if (!dataList.length) {
                              for (ii in qd.data) {
                                _arr = ii.split(":");
                                dataList.push("".concat(_arr[0], ":").concat(_arr[1]));
                              }
                            }

                            querylist.push(_objectSpread({}, qd.data));
                            _context.next = 14;
                            break;

                          case 12:
                            _this3.reqLoading = false;
                            return _context.abrupt("return", "break");

                          case 14:
                            _context.next = 19;
                            break;

                          case 16:
                            defaultData = {};
                            dataList.forEach(function (iii) {
                              defaultData[iii + ':' + searchHoour[i]] = {
                                roll: {
                                  "roll_server_register_pnum": 0,
                                  "roll_server_login_pnum": 0,
                                  "roll_server_recharge_pnum": 0,
                                  "roll_server_recharge_amount": 0,
                                  "roll_pay_percent": 0,
                                  "roll_arpu": 0,
                                  "roll_arppu": 0,
                                  "roll_register_arpu": 0
                                },
                                total: {
                                  "server_register_pnum": 0,
                                  "server_login_pnum": 0,
                                  "server_recharge_pnum": 0,
                                  "server_recharge_amount": 0,
                                  "server_recharge_amountexchange": 0,
                                  "pay_percent": 0,
                                  "arpu": 0,
                                  "arppu": 0,
                                  "register_arpu": 0
                                }
                              };
                            });

                            if (i > todayHoure) {
                              querylist.push(defaultData);
                            }

                          case 19:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _loop);
                  });
                  k = 0;

                case 31:
                  if (!(k < _this3.hourList.length)) {
                    _context3.next = 39;
                    break;
                  }

                  return _context3.delegateYield(_loop(k), "t0", 33);

                case 33:
                  _ret = _context3.t0;

                  if (!(_ret === "break")) {
                    _context3.next = 36;
                    break;
                  }

                  return _context3.abrupt("break", 39);

                case 36:
                  k++;
                  _context3.next = 31;
                  break;

                case 39:
                  queryData = {
                    code: 200,
                    data: _objectSpread({}, cacheHourData)
                  };
                  querylist.forEach(function (i) {
                    queryData.data = _objectSpread(_objectSpread({}, queryData.data), i);
                  });
                  handleQueryData(queryData);
                  _context3.next = 70;
                  break;

                case 44:
                  if (!(JSON.stringify(dbres.content.dataNew) != "{}")) {
                    _context3.next = 48;
                    break;
                  }

                  res.data = dbres.content.dataNew;
                  _context3.next = 70;
                  break;

                case 48:
                  _querylist = [];
                  _dataList = [];
                  _i = 0;

                case 51:
                  if (!(_i < searchHoour.length)) {
                    _context3.next = 67;
                    break;
                  }

                  if (!(parseInt(searchHoour[_i]) >= parseInt(_this3.PointTime[0]) && parseInt(searchHoour[_i]) <= parseInt(_this3.PointTime[1]))) {
                    _context3.next = 64;
                    break;
                  }

                  Hds = {
                    hour_start: searchHoour[_i],
                    hour_end: searchHoour[_i]
                  };
                  _context3.next = 56;
                  return reqFn(_objectSpread(_objectSpread(_objectSpread({}, _this3.searchData), _this3.defaultData()), {}, {
                    date: date
                  }, Hds));

                case 56:
                  qd = _context3.sent;

                  if (!(qd.status == 200 || qd.code == 200)) {
                    _context3.next = 62;
                    break;
                  }

                  if (!_dataList.length) {
                    for (ii in qd.data) {
                      _arr2 = ii.split(":");

                      _dataList.push("".concat(_arr2[0], ":").concat(_arr2[1]));
                    }
                  }

                  _querylist.push(_objectSpread({}, qd.data));

                  _context3.next = 64;
                  break;

                case 62:
                  _this3.reqLoading = false;
                  return _context3.abrupt("break", 67);

                case 64:
                  _i++;
                  _context3.next = 51;
                  break;

                case 67:
                  // const queryData = await reqFn({ ...this.searchData, ...this.defaultData(), date: date });
                  _queryData = {
                    code: 200,
                    data: {}
                  };

                  _querylist.forEach(function (i) {
                    _queryData.data = _objectSpread(_objectSpread({}, _queryData.data), i);
                  });

                  handleQueryData(_queryData);

                case 70:
                  _context3.next = 86;
                  break;

                case 72:
                  _queryData2 = {
                    code: 200,
                    data: {}
                  };
                  _querylist2 = [];
                  _dataList2 = [];
                  _loop2 = /*#__PURE__*/regeneratorRuntime.mark(function _loop2(_i2) {
                    var defaultData, _Hds, _qd, _ii, _arr3;

                    return regeneratorRuntime.wrap(function _loop2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!(parseInt(searchHoour[_i2]) >= parseInt(_this3.PointTime[0]) && parseInt(searchHoour[_i2]) <= parseInt(_this3.PointTime[1]))) {
                              _context2.next = 20;
                              break;
                            }

                            if (!(today == date && parseInt(searchHoour[_i2]) > todayHoure)) {
                              _context2.next = 8;
                              break;
                            }

                            defaultData = {};

                            _dataList2.forEach(function (iii) {
                              defaultData[iii + ':' + searchHoour[_i2]] = {
                                roll: {
                                  "roll_server_register_pnum": 0,
                                  "roll_server_login_pnum": 0,
                                  "roll_server_recharge_pnum": 0,
                                  "roll_server_recharge_amount": 0,
                                  "roll_pay_percent": 0,
                                  "roll_arpu": 0,
                                  "roll_arppu": 0,
                                  "roll_register_arpu": 0
                                },
                                total: {
                                  "server_register_pnum": 0,
                                  "server_login_pnum": 0,
                                  "server_recharge_pnum": 0,
                                  "server_recharge_amount": 0,
                                  "server_recharge_amountexchange": 0,
                                  "pay_percent": 0,
                                  "arpu": 0,
                                  "arppu": 0,
                                  "register_arpu": 0
                                }
                              };
                            });

                            _queryData2.data = _objectSpread(_objectSpread({}, _queryData2.data), defaultData);

                            _this3.dataHandle(_queryData2.data);

                            _context2.next = 20;
                            break;

                          case 8:
                            _Hds = {
                              hour_start: searchHoour[_i2],
                              hour_end: searchHoour[_i2]
                            };
                            _context2.next = 11;
                            return reqFn(_objectSpread(_objectSpread(_objectSpread({}, _this3.searchData), _this3.defaultData()), {}, {
                              date: date
                            }, _Hds));

                          case 11:
                            _qd = _context2.sent;

                            if (!(_qd.status == 200 || _qd.code == 200)) {
                              _context2.next = 18;
                              break;
                            }

                            if (!_dataList2.length) {
                              for (_ii in _qd.data) {
                                _arr3 = _ii.split(":");

                                _dataList2.push("".concat(_arr3[0], ":").concat(_arr3[1]));
                              }
                            }

                            _queryData2.data = _objectSpread(_objectSpread({}, _queryData2.data), _qd.data);

                            _this3.dataHandle(_queryData2.data);

                            _context2.next = 20;
                            break;

                          case 18:
                            _this3.reqLoading = false;
                            return _context2.abrupt("return", "break");

                          case 20:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _loop2);
                  });
                  _i2 = 0;

                case 77:
                  if (!(_i2 < searchHoour.length)) {
                    _context3.next = 85;
                    break;
                  }

                  return _context3.delegateYield(_loop2(_i2), "t1", 79);

                case 79:
                  _ret2 = _context3.t1;

                  if (!(_ret2 === "break")) {
                    _context3.next = 82;
                    break;
                  }

                  return _context3.abrupt("break", 85);

                case 82:
                  _i2++;
                  _context3.next = 77;
                  break;

                case 85:
                  // const queryData = await reqFn({ ...this.searchData, ...this.defaultData(), date: date });
                  handleQueryData(_queryData2);

                case 86:
                  _this3.reqLoading = false;

                case 87:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    dataHandle: function dataHandle(data) {
      var newData = JSON.parse(JSON.stringify(data));
      this.tableData = []; // Data

      for (var i in newData) {
        var arr = i.split(":");
        newData[i].total.pay_percent = (newData[i].total.pay_percent * 100).toFixed(2);
        newData[i].total.register_arpu = this.$utils.conversion(newData[i].total.register_arpu).toFixed(2);
        newData[i].total.arppu = this.$utils.conversion(newData[i].total.arppu).toFixed(2);
        newData[i].total.arpu = this.$utils.conversion(newData[i].total.arpu).toFixed(2);
        newData[i].total.server_recharge_amountexchange = this.isyjfmvnd() ? (Number(newData[i].total.server_recharge_amount) * this.exchangeRate).toFixed(2) : this.$utils.conversion(Number(newData[i].total.server_recharge_amount) * this.exchangeRate).toFixed(2);
        newData[i].total.server_recharge_amount = this.isyjfmvnd() ? newData[i].total.server_recharge_amount.toFixed(2) : this.$utils.conversion(newData[i].total.server_recharge_amount).toFixed(2);
        newData[i].roll.roll_arppu = this.$utils.conversion(newData[i].roll.roll_arppu).toFixed(2);
        newData[i].roll.roll_pay_percent = (newData[i].roll.roll_pay_percent * 100).toFixed(2);
        newData[i].roll.roll_arpu = this.$utils.conversion(newData[i].roll.roll_arpu).toFixed(2);
        newData[i].roll.roll_register_arpu = this.$utils.conversion(newData[i].roll.roll_register_arpu).toFixed(2);
        newData[i].roll.roll_server_recharge_amount = this.$utils.conversion(newData[i].roll.roll_server_recharge_amount).toFixed(2);
        this.tableData.push(_objectSpread(_objectSpread({
          server_id: arr[0],
          date: arr[1],
          hours: parseInt(arr[2]) + '~' + parseInt(Number(arr[2]) + 1)
        }, newData[i].roll), newData[i].total));
      }
    }
  }
};